import { getWindow } from "./armor-system-4JVSZEDO.js";

// src/util/stripHTMLTags.ts
import { isValidElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
var stripHTMLTags = function stripHTMLTags(markup) {
  var win = getWindow();
  var isReactElement = isValidElement(markup);
  if (!isReactElement) {
    return markup.toString();
  }
  if (!win) {
    return "";
  }
  var staticMarkup = renderToStaticMarkup(markup);
  var div = document.createElement("div");
  div.innerHTML = staticMarkup;
  var textFromMarkup = div.textContent || div.innerText || "";
  return textFromMarkup;
};
var stripHTMLTagsMemoized = function () {
  var cachedMap = /* @__PURE__ */new WeakMap();
  return function (markup) {
    if (!isValidElement(markup)) {
      return markup.toString();
    }
    if (cachedMap.has(markup)) {
      return cachedMap.get(markup) || "";
    }
    var textFromMarkup = stripHTMLTags(markup);
    if (textFromMarkup) {
      cachedMap.set(markup, textFromMarkup);
    }
    return textFromMarkup;
  };
}();
export { stripHTMLTags, stripHTMLTagsMemoized };